(function () {
  'use strict';

  function initScrollReveal() {
    var targets = document.querySelectorAll('.ad-reveal, .lux-reveal');
    if (!targets.length) return;

    if (!('IntersectionObserver' in window)) {
      targets.forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
    );

    targets.forEach(function (el) {
      observer.observe(el);
    });
  }

  function initHeaderScroll() {
    var header = document.querySelector('.ad-header');
    if (!header) return;

    var threshold = 60;

    function update() {
      if (window.scrollY > threshold) {
        header.classList.add('ad-header--solid');
      } else {
        header.classList.remove('ad-header--solid');
      }
    }

    update();
    window.addEventListener('scroll', update, { passive: true });
  }

  function initMobileNav() {
    var burger = document.querySelector('[data-ad-menu-open]');
    var close = document.querySelector('[data-ad-menu-close]');
    var nav = document.querySelector('[data-ad-mobile-nav]');
    if (!burger || !nav) return;

    burger.addEventListener('click', function () {
      nav.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });

    function closeNav() {
      nav.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    if (close) close.addEventListener('click', closeNav);

    nav.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', closeNav);
    });
  }

  function initBottleParallax() {
    var cards = document.querySelectorAll('.ad-product-card__media');
    if (!cards.length || window.matchMedia('(pointer: coarse)').matches) return;

    cards.forEach(function (card) {
      var img = card.querySelector('.ad-product-card__img');
      if (!img) return;

      card.addEventListener('mousemove', function (event) {
        var rect = card.getBoundingClientRect();
        var x = (event.clientX - rect.left) / rect.width - 0.5;
        var y = (event.clientY - rect.top) / rect.height - 0.5;
        img.style.transform = 'scale(1.06) translate(' + x * -10 + 'px, ' + y * -10 + 'px)';
      });

      card.addEventListener('mouseleave', function () {
        img.style.transform = '';
      });
    });
  }

  function initProcessTimeline() {
    var track = document.querySelector('.ad-proceso__track');
    if (!track) return;

    var steps = track.querySelectorAll('.ad-proceso__step');
    if (!('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
          }
        });
      },
      { threshold: 0.4 }
    );

    steps.forEach(function (step) {
      observer.observe(step);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initScrollReveal();
    initHeaderScroll();
    initMobileNav();
    initBottleParallax();
    initProcessTimeline();
  });
})();
